import React, { Component, useState, useEffect, useLayoutEffect, useContext } from 'react'
import ReactDOM from 'react-dom'
import IScroll from 'iscroll'

import './css/styles.scss'

import CartClass from './../../../../../../../js/classes/Cart'

import Loading from './Loading.jsx'

import Cart from './Cart.jsx'
import Summary from './Summary.jsx'

import DataContext from '../../../../order/templates/.default/react/contexts/data.jsx'

const CartSmallApp = ({ orderData }) => {
    let cartItemsScroll = null

    const data = useContext(DataContext)

    const [cart, setCart] = useState(null),
    [deliveryPrice, setDeliveryPrice] = useState(null),
    [isLoading, setLoading] = useState(false)

    const iScrollUpdate = () => {
        if (cartItemsScroll) {
            cartItemsScroll.destroy()
        }

        cartItemsScroll = new IScroll('.happy-cart-small__wrapper', {
            mouseWheel: true,
            scrollbars: true
        })
    },
    refetch = (cb) => {
        setLoading(true)

        CartClass.getCart((err, cart) => {
            if (err) {
                
            } else {
                setCart(cart)
            }

            setLoading(false)
            iScrollUpdate()

            if (cb) cb(err, cart)
        }, undefined, true, data?.payments?.id)
    },
    setAutoScrollCart = () => {
        var rSide = document.querySelector('#root-order')
		
		if (rSide) {
			var sTop = window.scrollY,
			lSide = document.querySelector('.happy-order__cart'),
			lSideA = lSide.querySelector('.happy-cart-small'),
			lSideH = lSideA.offsetHeight,
			yLTop = lSide.offsetTop,
			yLBottom = sTop + lSideH,
			yRTop = rSide.offsetTop,
			rSideH = rSide.offsetHeight,
			yRBottom = yRTop + rSideH

			if (sTop > yLTop && rSideH > lSideH) {
				if (yLBottom > yRBottom) {
					lSideA.style.top = yRBottom - lSideH - yLTop + 'px'
				} else {
					lSideA.style.top = sTop - yLTop + 'px'
				}
			} else {
				lSideA.style.top = '0px'
			}
		}
    }

    useEffect(() => {
        refetch()
    }, [data?.payments?.id])

    useEffect(() => {
        refetch()

        window.addEventListener('scroll', setAutoScrollCart)
        window.addEventListener('resize', setAutoScrollCart)
        document.addEventListener('DOMContentLoaded', setAutoScrollCart)



        return () => {
            window.removeEventListener('scroll', setAutoScrollCart)
            window.removeEventListener('resize', setAutoScrollCart)
            window.removeEventListener('DOMContentLoaded', setAutoScrollCart)
        }
    }, [])

    useLayoutEffect(() => {
        if (orderData && orderData.delivery && orderData.delivery.id > 0) {
            const delivery = orderData.data._delivery[orderData.delivery.id]

            if (delivery.NAME.toLowerCase() === 'самовывоз') {
                setDeliveryPrice(0)
            } else {
                if ((delivery.PRICE === null && delivery.PERIOD === null) || delivery.NAME.toUpperCase().includes('СБЕР')) {
                    setDeliveryPrice(false)
                } else {
                    setDeliveryPrice(delivery.PRICE)
                }
            }
        }
    })

    return <div className={ `happy-cart-small` + (isLoading ? ` happy-cart-small__loading` : ``) }>
        { cart ? <>
            <div className="happy-cart-small__title">
                В корзине { cart.count_format }
            </div>

            <div className="happy-cart-small__data">
                <Cart
                    cart={ cart }
                    iScrollUpdate={ iScrollUpdate }
                />
            </div>

            <div className="happy-cart-small__footer">
                <Summary
                    refetch={ refetch }
                    cart={ cart }
                    deliveryPrice={ deliveryPrice }
                    setLoading={ setLoading }
                    iScrollUpdate={ iScrollUpdate }
                />
            </div>
        </> : <Loading /> }
    </div>
}

export default CartSmallApp